const url = '/auth';
const register = `${url}/register`;
const login = `${url}/login`;
const logout = `${url}/logout`;
const forgotPassword = '/forgotPassword';
const resetPassword = '/resetPassword';
const Provider = 'Auth';

export { url, Provider, register, login, logout, forgotPassword, resetPassword };
